import React from 'react';
import "../../styles/Principles.css"; 

export default function Principles() {
  const pillars = [
    { glyph: "🛡️", color: "color-blue", title: "Integrity", desc: "We are honest, transparent and ethical in everything we do." },
    { glyph: "💡", color: "color-orange", title: "Innovation", desc: "We constantly innovate to make learning better and more accessible." },
    { glyph: "🎯", color: "color-indigo", title: "Impact", desc: "We are committed to creating real impact in the lives of creators." },
    { glyph: "🤝", color: "color-gold", title: "Inclusivity", desc: "We believe in equal opportunities for every aspiring creator." },
    { glyph: "❤️", color: "color-pink", title: "Passion", desc: "We love what we do and it reflects in our work and community." }
  ];

  return (
    <section className="about-client-principles-block">
      <div className="about-client-max-width">
        
        
        <div className="section-centered-header-node">
          <span className="client-uppercase-overline gold-text">OUR CORE VALUES</span>
          <h2 className="client-section-title">The Principles That Drive Us</h2>
        </div>
        
        
        <div className="principles-five-lane-grid-layout">
          {pillars.map((pillar, idx) => (
            <div className={`principle-card-custom ${pillar.color}`} key={idx}>
              
              
              <div className="principle-icon-wrapper">
                <span className="principle-glyph">{pillar.glyph}</span>
              </div>
              
              
              <div className="principle-text-content">
                <h4>{pillar.title}</h4>
                <p>{pillar.desc}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}